var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app" },
    [
      _c("session", { ref: "session" }),
      _vm._v(" "),
      _c("tracker", { ref: "tracker" }),
      _vm._v(" "),
      _c("modal-component", {
        attrs: { modal: _vm.modal },
        on: {
          action: _vm.handleModalAction,
          close: function($event) {
            _vm.modal = null
          },
          changeModal: function($event) {
            _vm.modal = $event
          }
        }
      }),
      _vm._v(" "),
      _c("navigation", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.includeNav.includes(_vm.$route.path),
            expression: "includeNav.includes($route.path)"
          }
        ],
        attrs: { user: _vm.user },
        on: {
          modal: function($event) {
            _vm.modal = $event
          },
          logout: function($event) {
            _vm.user = null
          }
        }
      }),
      _vm._v(" "),
      _c(
        "main",
        { staticClass: "container" },
        [
          _c("router-view", {
            attrs: { user: _vm.user },
            on: {
              changeModal: function($event) {
                _vm.modal = $event
              },
              logout: function($event) {
                _vm.user = null
              }
            }
          }),
          _vm._v(" "),
          _c("subscription", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.canSubscribe && !_vm.subscriptionComplete,
                expression: "canSubscribe && !subscriptionComplete"
              }
            ],
            ref: "sub"
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("custom-footer", {
        on: {
          changeModal: function($event) {
            _vm.modal = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }